import React from "react";
import "./Contact.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import '@fortawesome/fontawesome-free/css/all.min.css';

const Contact = () => {
  return (
    <>
      <Navbar />

      {/* About Us Section */}
      <div className="contact-section">
        <h2 className="contact-title">Contact Us</h2>
      </div>

      <div className="below-hero-section2">
        <p>
        At Globus Trading, your success is our priority. Whether you need assistance with your account, have questions about our trading platform, or need expert advice on forex strategies, our dedicated support team is here for you. Reach out to us through any of the following methods, and we’ll respond promptly.
        </p>
      </div>
      <div className="contact-container">
        {/* Left Column - Contact Form */}
        <div className="contact-form">
          <h2>Send us a Message</h2>
          <form>
            <input type="text" placeholder="Name" required />
            <div className="input-row">
              <input type="email" placeholder="Email" required />
              <input type="tel" placeholder="Phone" />
            </div>
            <textarea placeholder="Message" required></textarea>
            <button type="submit">Send</button>
          </form>
        </div>

        {/* Right Column - Contact Details */}
        <div className="contact-info">
          <h2>Get In Touch</h2>
          <p><i className="fas fa-map-marker-alt"></i> Bonovo Road – Fomboni Island of Mohéli – Comoros Union.</p>
          <p><i className="fas fa-envelope"></i> support@globustrading.co</p>
        </div>
      </div>
      

      <Footer />
    </>
  );
};

export default Contact;
